import React from 'react';
import { IconProps } from '.';

type ReviewIconProps = {} & IconProps;

export const ReviewIcon: React.FC<ReviewIconProps> = ({
  height = 24,
  width = 24,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 35 35"
    >
      <path
        fill="#222427"
        d="M31.675 7.904l-4.054-4.01a1.458 1.458 0 00-1.969 0l-15.094 14.86a1.24 1.24 0 00-.306.452l-2.742 6.68a1.37 1.37 0 00.307 1.458c.265.248.613.389.977.394.18.002.359-.032.525-.102l6.796-2.698c.171-.068.326-.172.452-.307L31.602 9.844l.073-.073a1.343 1.343 0 00.408-.963 1.371 1.371 0 00-.408-.962v.058zM11.142 20.11l4.025 3.967-4.74 1.881-1.21-1.18 1.925-4.668zM30.844 8.954L16.158 23.406l-1.05-1.02 11.098-10.88a.583.583 0 00-.831-.816L14.277 21.569l-2.494-2.45L26.47 4.652a.233.233 0 01.306 0l4.054 3.996a.19.19 0 010 .146.175.175 0 010 .146"
      ></path>
      <path
        fill="#222427"
        d="M27.606 16.173a.583.583 0 00-.598.583v13.388a.233.233 0 01-.248.233H4.331a.248.248 0 01-.248-.233V8.269a.248.248 0 01.248-.248h14.817a.583.583 0 000-1.167H4.33a1.458 1.458 0 00-1.458 1.459v21.83a1.458 1.458 0 001.458 1.46h22.4a1.458 1.458 0 001.459-1.46V16.816a.583.583 0 00-.584-.584"
      ></path>
    </svg>
  );
};
